import { ItemTypes } from "game-common/item/item_type"
import { ItemTypeMeta } from "../item/item"

import { Coordinate, MapSpriteCap, WeaponType } from "../models"
import { EntityTileTypes } from "../item/item_entity_tiles"

export type OreMaterial = "coal" | "iron" | "copper" | "silver" | "gold"

export interface MapDelta {
    x: number
    y: number
    blocking?: boolean
    occlusion?: boolean
    tileId?: string
    removed?: boolean
    layerId?: string
    surfaceId?: string
    mapSpriteCap?: MapSpriteCap
    temporary?: boolean
    collideable?: boolean
    context?: {
        wallFaction?: string
        tileInteractions?: import("../entity_tile_interactions").TileInteraction[]
        parent?: Coordinate
        surfaceId?: string
        itemType?: ItemTypes
        hp?: number
        hpMax?: number
        highZ?: boolean
        previewTarget?: boolean
        bonecallerShrineId?: string
        bonecallerStoneIndex?: number
        /** Visible mineral kind; reward quantities remain in server campaign state. */
        oreMaterial?: OreMaterial
    }
}

export type TileEffectType = "damage" | "destroy" | "remove" | "overlay"

export interface TileEffect {
    mapRoughCoordinates: Coordinate
    effectType: TileEffectType
    surfaceId?: string
    tileId?: string
    overlayTileId?: string
    entityTile?: EntityTile
    hpPct?: number
    hp?: number
    hpMax?: number
}

export type EntityTile = (typeof EntityTileTypes)[number]

export const isTreeEntityTile = (tile: EntityTile) =>
    ["tree1", "tree2", "tree3", "tree4", "tree5", "tree6", "smallTree1"].includes(tile)

// The mineable rock blocks. Like a tree, each is drawn TALLER than the cell it blocks -- the art
// reaches a row above its foot (see fillEmberCaveOre, which keeps that row clear) -- so a block sitting
// one row south of the player covers the player's body. That is why the client's occluder-fade treats
// them as candidates alongside trees.
export const isOreEntityTile = (tile: EntityTile) => ["ore-coal", "testore"].includes(tile)

interface GrowthDescriptor {
    entityTileId: EntityTile
    requiredTime: number
}

interface ItemCreationDescriptor {
    itemType: ItemTypeMeta
    quantity: number
    replicate?: boolean
    probability?: number
}

export interface EntityTileMeta {
    hp: number
    growthSequence?: GrowthDescriptor[]
    onDestructionCreateItems?: ItemCreationDescriptor[]
}

export type EntityTileDamageMeta = {
    weaponType: WeaponType
    damage: number
}
